import { usePermissionsRepository } from '@Hooks/useRepository';
import { PartnershipsRepository } from '@Repositories/Permissions';
import { useMutation } from '@tanstack/react-query';

// @ai-generated 2026-05-06T12:05:10+00:00 by matthias.gessinger@synqony.com using Claude Opus 2.7
export const useLockPartnership = (partnershipId: string, onMutate: () => void) => {
    const partnerships = usePermissionsRepository(PartnershipsRepository);

    const { mutateAsync: lockAsync, isPending: lockPartnershipIsPending } = useMutation({
        mutationFn: () => partnerships.lockPartnership(partnershipId),
        onSuccess: onMutate,
    });
    const { mutateAsync: unlockAsync, isPending: unlockPartnershipIsPending } = useMutation({
        mutationFn: () => partnerships.unlockPartnership(partnershipId),
        onSuccess: onMutate,
    });

    return { lockAsync, unlockAsync, lockPartnershipIsPending, unlockPartnershipIsPending };
};
